import axios from "axios";
import React, { useState } from "react";
import { ISiteV2 } from "../../../../interfaces/Site";
import { QuickStartContext } from "../../../../../contexts/QuickStartContext";
import { IError } from "../../../../../App";
import { IContentDataImage } from "../../../../interfaces/IContentData";
import { logError } from "../../../../utils/LogError";
import Loading from "../../../../components/Loading/Loading";
import ShowError from "../../../../components/ShowError/ShowError";
import { FilesUpload } from "../../../../components/FilesUpload/FilesUpload";

interface IProps {
    site: ISiteV2;
    updateContentData: (image: IContentDataImage) => void;
    onSuccess?: () => void;
    setIsUploading: (isUploading: boolean) => void;
    isUploading: boolean;
}

export function UploadImages(props: IProps) {
    const [status, setStatus] = useState({ total: 0, uploading: 0 });
    const [error, setError] = useState<IError | null>(null);

    const isQuickStart = React.useContext(QuickStartContext);

    const handleFileUpload = async (files: File[]) => {
        props.setIsUploading(true);
        setStatus({ total: files.length, uploading: 0 });
        let hasError = false;

        try {
            for (const file of files) {
                const data = new FormData();
                data.append("file", file);
                setStatus((prev) => ({ total: files.length, uploading: prev.uploading + 1 }));

                const response = await axios.post(
                    process.env.REACT_APP_API_URL +
                        "/api/sites/" +
                        (isQuickStart ? "quick-start" : props.site._id) +
                        "/upload-image",
                    data
                );

                props.updateContentData({
                    contentDataType: "Image",
                    image: {
                        path: response.data.path,
                        originalName: response.data.originalName,
                        fileName: response.data.fileName,
                        temporary: response.data.temporary,
                        isDemoImage: !!props.site.quickStart && !response.data.temporary,
                        sizes: response.data.sizes,
                        width: response.data.width,
                        height: response.data.height,
                    },
                });
            }
        } catch (err) {
            logError(
                "generator.SiteModuleImageGallery.uploadImages.handleFileUpload",
                err,
                1,
                {
                    path:
                        process.env.REACT_APP_API_URL +
                        "/api/sites/" +
                        (isQuickStart ? "quick-start" : props.site._id) +
                        "/upload-image",
                },
                props.site
            );
            setError({ text: "Misslyckades att ladda upp bilden", response: (err as any).response });
            hasError = true;
        } finally {
            props.setIsUploading(false);
            if (props.onSuccess && !hasError) {
                props.onSuccess();
            }
        }
    };

    return (
        <>
            {props.isUploading === true && <Loading text={"Laddar upp bild " + status.uploading + " av " + status.total} />}
            <ShowError error={error} />
            <FilesUpload
                onFilesUpload={handleFileUpload}
                buttonText="Klicka här eller dra och släpp för att ladda upp bilder"
            />
        </>
    );
}
